import {useQuery} from '@apollo/client';
import React, {memo} from 'react';
import {RouteComponentProps} from 'react-router';
import {ErrorComponent} from '../../../Component/Error/ErrorComponent';
import {LoadingComponent} from '../../../Component/Loading/LoadingComponent';
import {AdminForm} from '../../Component/Form/AdminForm';
import {AdminCrudPage} from '../../Component/Page/AdminCrudPage';
import {getUserEditQuery} from '../../GraphQL/Query/getUserEditQuery';
import {getUserEdit} from '../../GraphQL/Query/types/getUserEdit';
import {FormValues} from '../../Model/Form/FormValues';

type Props = RouteComponentProps<{
  id: string;
}>;

export const UserAdminEditScreen: React.FC<Props> = memo(({match}) => {
  const {loading, error, data} = useQuery<getUserEdit>(getUserEditQuery, {
    fetchPolicy: 'network-only',
    variables: {id: parseInt(match.params.id, 10)},
  });

  let form;
  if (data) {
    const {organisation, ...initialValues} = data.user;
    (initialValues as unknown as FormValues).organisationId = organisation.id;
    form = (
      <AdminForm
        initialValues={(initialValues as unknown as FormValues)}
        mutationName="editUser"
        redirectUrl="/admin/user"
      />
    );
  }

  return (
    <AdminCrudPage entityType="user" action="Edit">
      {loading && <LoadingComponent/>}
      {(!loading && (error || !data)) && <ErrorComponent/>}
      {form}
    </AdminCrudPage>
  );
}, (prevProps, nextProps) => prevProps.match.params.id === nextProps.match.params.id);
